module.exports = __webpack_public_path__ + "static/media/fastcheckout-success-es.b49044a3.png";